<template>
  <b-modal id="updateAgreementConsentModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreementconsent.updateAgreementConsentHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="agreementConsent">
      <b-col>
        <EXCMAgreementConsentUpdate :agreementConsentId="agreementConsent['@id']"></EXCMAgreementConsentUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementConsentUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateAgreementConsentModal',
  components: {
    EXCMAgreementConsentUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreementconsent.update.show
    },
    consentPivot () {
      return this.$store.state.modals.excmagreementconsent.update.consentPivot
    },
    close () {
      return this.$store.state.modals.excmagreementconsent.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'consentPivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreementConsent: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.consentPivot) {
        this.agreementConsent = Object.assign({}, this.consentPivot)
        this.$store.state.modals.excmagreementconsent.update.show = 0
        this.$store.state.modals.excmagreementconsent.update.consentPivot = null
        this.$bvModal.show('updateAgreementConsentModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreementconsent.update.close = 0
        this.$bvModal.hide('updateAgreementConsentModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
